import { render, staticRenderFns } from "./CarPurchaseRights.vue?vue&type=template&id=1db5035a&scoped=true"
import script from "./CarPurchaseRights.vue?vue&type=script&lang=js"
export * from "./CarPurchaseRights.vue?vue&type=script&lang=js"
import style0 from "./CarPurchaseRights.vue?vue&type=style&index=0&id=1db5035a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1db5035a",
  null
  
)

export default component.exports